






















import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { IPageParams } from '../../models';
import paginationMixin from '@/mixins/pagintation';
@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'companyType',
  }),
  mixins: [paginationMixin],
})
export default class CompanyTypeList extends Vue {
  @Action('getEntities', { namespace: 'companyType' })
  getEntities: () => void;
  @Getter('entitiesSlice', { namespace: 'companyType' })
  entitiesSlice: CompanyTypeList[];
  @State('pageParams', { namespace: 'companyType' }) pageParams: IPageParams;
  headers = [{ text: 'Название', value: 'name' }];
  selected = [];
  interval = null;
  created() {
    this.getEntities();
  }
}
